export function chooseUrl(start, route, results, inputs, navigate) {
  if (route === 'searchResults') {
    const inputParam = inputs ? `&inputs=${JSON.stringify(inputs)}` : ''
    navigate(`/${route}/${results.search.id}?start=${start}${inputParam}`)
  } else {  //statistics
    let inputsstring = ''
    if (inputs.userId) {
      inputsstring += `&userId=${inputs.userId}`
    }
    if (inputs.fromDate) {
      inputsstring += `&fromDate=${inputs.fromDate}`
    }
    if (inputs.toDate) {
      inputsstring += `&toDate=${inputs.toDate}`
    }
    navigate(`/${route}?eventId=${inputs.eventId}${inputsstring}&start=${start}`)
  }
}